module.exports = __webpack_public_path__ + "static/media/botoncobrador.0a7384d0.png";